import React from "react"
import { MoonLoader } from "react-spinners"

type Props = {
  children: React.ReactNode
  isLoading: boolean
  topPadding?: string
}
const LoadingInputWrapper = ({ children, isLoading, topPadding }: Props) => {
  return (
    <div className="w-full flex gap-2">
      {children}

      {isLoading && (
        <span
          className={`flex items-center justify-center ${
            topPadding ? topPadding : "mt-6"
          } `}
        >
          <MoonLoader color="#3b82f6" size={24} />
        </span>
      )}
    </div>
  )
}

export default LoadingInputWrapper
